<template>
  <div 
    :class="['leaders__tabs', (!isMain) ? 'leaders__tabs_small m-0' : '']"
    :style="(isMain) ? 'margin-left: 0;' : ''"
    >
    <router-link
      v-if="isMain"
      v-for="(tab, i) in tabs"
      :key="i"
      :to="tabRoute(tab.name)"
      :class="[
        'leaders__tab', 'leaders__tab_main', activeTab === tab.name ? 'active' : ''
      ]"
    >
      {{ tab.name.charAt(0).toUpperCase() + tab.name.slice(1) }}
    </router-link>
    <link-event
      v-if="!isMain"
      v-for="(tab, i) in tabs"
      :key="i"
      :round="tab"
      :class="[
        'leaders__tab', 'leaders__tab_round', isActive(tab)
      ]"
    >
      {{ (isEventPage && tab.name == 'Final') ? 'Final round'  
        : (isEventPage && tab.name && tab.name.toLowerCase().includes('run-off') 
          ? tab.name.toUpperCase() 
          : tab.name)  
      }}
    </link-event>
  </div>
</template>

<script>
import LinkEvent from './Links/LinkEvent'

export default {
  components: {
    'link-event': LinkEvent
  },
  props: {
    isEventPage: {
      type: Boolean,
      required: false,
      default: false
    },
    tabs: {
      type: Array,
      required: true
    },
    event: {
      type: Object,
      required: false,
      default: () => ({})
    },
    isMain: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    tabRoute(name) {
      return {
        name: this.$route.name,
        params: this.$route.params,
        query: { ...this.$route.query, tab: name }
      }
    },
    isActive(tab) {
      if (tab.round === Number(this.event.current_active_round)) {
        return 'active'
      }
      if (tab.round === Number(this.$route.params?.round)) {
        return 'active'
      }
      return ''
    }
  },
  computed: {
    activeTab() {
      return this.$route.query.tab || this.tabs[0].name
    }
  }
}
</script>

<style scoped>
  .leaders__tabs {
    border-color: var(--apperances-color) !important;
  }

  .leaders__tab {
    color: var(--apperances-color) !important;
    border-left-color: var(--apperances-color) !important;
  }

  .leaders .leaders__tab.active {
    background-color: var(--apperances-color) !important;
    color: var(--white) !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/Leaders/Listing/components/RoundTabs.vue